<template>
  <div class="agree-box">
    <div class="scroll-box">
      <div class="content">
        <!--精臣隐私保护政策-->
        <h2 class="bold text-center">隐私保护政策</h2>
        <section>
          <p class="text-right">本版发布日期：2024年7月2日</p>
        </section>
        <section>
          <p class="bold">概述</p>
        </section>
        <section>
          <p class="mb20">
            我们深知个人信息对您而言的重要性，也感谢您对我们的信任。我们将通过本政策向您说明【精臣进销存】会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，其中要点如下：
          </p>
        </section>
        <section>
          <p>
            1.为了便于您了解您在使用我们的服务时，我们需要收集的信息类型与用途，我们将结合具体服务向您逐一说明。
          </p>
          <p>
            2.为了向您提供更好的产品和服务，我们会按照合法、正当、必要的原则收集您的信息。
          </p>
          <p>
            3.如为了向您提供更好的产品和服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并严格遵守国家相关法律法规要求。
          </p>
          <p>
            4.如为了向您提供更好的产品和服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。如我们开展业务需进行的个人信息处理活动超过您的授权范围，我们将征得您的明确同意。
          </p>
          <p>
            5.您可以通过本政策介绍的方式访问和管理您的信息，设置隐私功能，注销账户或投诉举报。
          </p>
        </section>
        <section>
          <p class="mb20">
            您可以根据以下索引阅读相关章节，进一步了解本政策的具体约定。
          </p>
        </section>
        <section>
          <p class="bold">一．我们如何收集信息</p>
          <p class="bold">二．我们如何存储和保护信息</p>
          <p class="bold">三．我们如何使用信息</p>
          <p class="bold">四．我们如何对外提供信息</p>
          <p class="bold">五．您如何访问和管理自己的信息</p>
          <p class="bold">六．对第三方责任的声明</p>
          <p class="bold">七．我们如何保护未成年人的信息</p>
          <p class="bold">八．本政策的适用与更新</p>
          <p class="bold mb20">九．其他</p>
        </section>

        <section>
          <p>
            武汉精臣智慧标识科技有限公司（客服电话：400-8608800，电子邮箱kefu@niimbot.com，下称“我们”）尊重并保护您的隐私。您使用我们的服务时，我们将按照本政策收集、存储、使用及对外提供您的信息。同时我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的信息的服务。<span
              class="bold"
              >本政策与您适用我们的服务关系紧密，我们建议您仔细阅读并理解本政策的全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和个人敏感信息，采用粗体字进行标注以提示您注意。如一旦您开始使用我们的产品或服务时，则视为您对本政策内容的接受和认可。</span
            >
          </p>
          <p class="mb20">
            我们将根据相关法律法规的规定、同时为了向您提供更好的产品或服务，我们需要收集、存储、使用及必要情况下对外提供您的信息。您同意我们按照本政策约定的方法处理您的信息，以便您享受优质、便捷的服务体验，同时更好的保护您的信息安全。
          </p>
        </section>
        <h3 class="bold">一、我们如何收集信息</h3>

        <p class="mb20">
          在您使用我们产品或服务的各项业务功能（下称“服务”）时，我们需要收集您的相关信息，用以向您提供更好的服务、保障您的信息安全及符合法律之规定。
        </p>

        <section>
          <p class="bold">1. 账户注册及登录</p>
          <p class="mb20">
            在您注册我们的产品或服务账户或者使用我们服务时，您需要将电子邮箱或手机号作为账户登录名，并设置账户密码，基于此我们可能收集您的基本身份信息和网络身份识别信息。基本身份信息包括手机号码、电子邮箱地址、微信及QQ的openId等第三方账号信息。网络身份识别信息包括账户名、账户密码、账户昵称、账户头像以及与前述有关的密码。
          </p>
          <p class="bold">2. 产品或服务的使用</p>
          <p>
            鉴于您需要通过【精臣进销存】进行商品的采购、库存、销售管理等录入、管理操作，同时在一些场景下，您需要通过【精臣进销存】以蓝牙的方式连接特定型号的便携式打印机，并在线录入待打印信息从而实现一键式快捷打印功能，我们可能需要收集如下信息:
          </p>
          <p>
            <span class="bold">（1）个人操作信息：</span>
            当您使用我们的服务时，我们会收集您对我们服务的使用情况，作为有关用户操作日志保存，包括您的打印内容、您自主录入的信息、搜索记录、模板使用历史数据、订单交易信息、IP地址、使用的语言、访问服务的日期和时间、个人操作记录、以及通过cookies获得的必要信息，收集这些信息的目的是方便我们为您提供数据保存、数据恢复等云服务，及时发现并防范信息泄露等安全风险，改善我们的产品和服务等，并有助于您获得更好的使用体验。
          </p>
          <p>
            <span class="bold">（2）移动通讯设备信息：</span>
            为了保障您正常使用我们的服务，解决功能使用中遇到的障碍或问题，我们可能会记录您使用的移动设备或您使用的用于接入我们服务的其他程序所提供的个人常用设备信息，可能包括手机型号、唯一设备标识符、设备信息（IP地址、设备制造商、设备型号、手机操作系统、设备标识符（IMEI/MAC/Android
            ID/IDFA/OpenUDID/GUID/SIM卡/IMSI
            ））等描述个人常用终端设备基本情况的信息，这些信息有助于我们发现功能故障并及时响应您提出的服务需求。
          </p>
          <p>
            <span class="bold">（3）打印设备及耗材信息：</span>
            为了提升用户体验，当您使用我们的服务时，我们将收集您相关的打印设备终端信息。例如，当您开启打印服务时，我们将会收集您的打印机及耗材信息，以精准匹配相关打印服务。我们将仅在实现服务目的必要权限内采集您的信息，并在本政策约束框架内使用、储存您的信息。
          </p>
          <p>
            <span class="bold">（4）其他具体服务信息：</span>
          </p>
          <p>
            <span class="bold">A.</span>
            您在使用服务时，上传和/或发布的信息以及进行相关行为，我们将收集您上传、发布或形成的信息，如该信息是你所在公司、单位或其他第三方的信息，您需确保您已经取得其授权同意。
          </p>
          <p class="bold">
            B.当您与我们联系时，我们可能会保存您的联系方式及相关信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果
            。
          </p>
        </section>
        <p class="mb20">
          <span class="bold">C.</span>
          当您选择参加我们的有关营销活动时，我们根据活动需要可能会收集您的<span
            class="bold"
            >姓名、通信地址、联系方式、支付账号。</span
          >该信息是您收到转账或者礼品的基础，如果您拒绝提供这些信息，我们将无法向您转账或发放礼品。
        </p>
        <p class="bold">3.设备权限调用汇总</p>
        <p>
          <span class="bold"
            >为了向您提供服务及保障您账户信息安全，【精臣进销存】需要在必要范围内向您申请获取列下权限。请您放心，我们不会默认开启这些权限，仅在您主动确认开启的情况下，我们才有可能通过这些权限收集您的信息。需要特别说明的是，我们在获取具体某项权限并不代表我们必然会收集您的相关信息；即使您已经确认开启相关权限，我们也会在合法、正当、必要的范围内收集您的信息。</span
          >对应的权限设置请参考使用对应功能的权限设置指引和手机设备及系统开发方说明或指引。
        </p>
        <p>
          <span class="bold"> 读取与写入存储器权限：</span
          >当您安装【精臣进销存】时，我们会向您申请获取此权限，目的是为了保障【精臣进销存】的稳定运行，我们承诺仅读取和缓存必要的信息。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【精臣进销存】提供的其他功能。
        </p>
        <p>
          <span class="bold">网络权限：</span
          >当您使用【精臣进销存】联网服务功能时，我们会向您申请获取此权限，目的是为了完成APP内容读取和更新。如您选择不开启此权限，您将无法使用与此权限相关的功能，只能使用【精臣进销存】提供的部分具备离线使用的功能。
        </p>
        <p>
          <span class="bold">蓝牙权限：</span
          >当您使用【精臣进销存】打印机蓝牙连接时，我们会向您申请获取此权限，目的是为了完成便携式蓝牙打印机的配对、连接和打印功能。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【精臣进销存】提供的其他功能。
        </p>
        <p>
          <span class="bold">定位权限：</span
          >当您使用【精臣进销存】打印机蓝牙连接，且您自身所使用的终端设备系统为安卓6.0以后的系统，我们会向您申请获取此权限，目的是为了完成蓝牙搜索打印机的功能，在安卓6.0以后的系统，必须打开位置权限才可以搜索到蓝牙设备。如您选择不开启此权限，您将无法使用与此权限相关的功能，只能使用【精臣进销存】提供的部分功能。
        </p>
        <p>
          <span class="bold">相机权限：</span
          >当您使用【精臣进销存】扫描商品的条形码/二维码、上传商品图片时，我们会向您申请获取此权限，目的是为了通过扫描识别商品、订单以及维护商品信息时上传商品图片等。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【进销存】提供的其他功能。
        </p>
        <p>
          <span class="bold">读取电话状态权限：</span
          >当您使用【精臣进销存】手机号一键快捷登录功能时，我们会向您申请获取此权限，目的是为了完成手机一键快捷登录。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【进销存】提供的其他功能。
        </p>
        <p>
          <span class="bold">读取联系人数据权限：</span
          >当您使用【精臣进销存】导入通讯录联系人作为供应商或/客户客户时，我们会向您申请获取此权限，是为了方便您快速维护商品的供应商/客户联系方式。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【进销存】提供的其他功能。
        </p>
        <p>
          <span class="bold">访问剪切板权限：</span
          >当您使用【精臣进销存】进行信息输入时，为了方便辅助用户快速输入信息，我们会读取、识别剪切板中的内容，以便提升信息输入的体验，我们不会收集、使用您剪切板中与本功能无关的隐私信息。
        </p>
        <p class="bold red mb20">
          麦克风权限
          当您使用【精臣进销存】语音识别的功能时，我们会向您申请获取此权限，目的是为了完成将语音识别成文字的功能。如您选择不开启此权限，您将无法使用与此权限相关的特定功能，但不影响您使用【精臣进销存】提供的其他功能。
        </p>

        <p class="bold">4.我们从第三方获得的您的信息</p>
        <p>
          我们可能从第三方获取您授权共享的账户信息，包括账户名、账户昵称、账户头像等，并在您同意本政策后将您的第三方账户与您的精臣软件账户绑定，使您可以通过第三方账户直接登录并使用我们的产品或服务。我们将会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律法规规定的前提下，使用您的上述个人信息。
        </p>
        <p>
          如果为了向您提供服务而需要从第三方获取您的个人信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。如果我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权范围，我们将征得您的明确同意。
        </p>
        <p class="bold">
          请您知悉，【精臣进销存】当中部分服务可能由我们的关联公司、合作伙伴或者其他第三方主体提供，为此【精臣进销存】内可能会嵌入关联公司、合作伙伴或者其他第三方主体的软件工具开发包（下称“SDK”）或其他类似的应用程序。我们会对SDK或其他类似的应用程序进行严格的安全检测，并要求关联公司、合作伙伴或者其他第三方主体采取严格的数据保护措施，切实保障您的合法权益。
        </p>
        <p class="bold mb20">更多详情，敬请查阅附件1：《第三方SDK目录》。</p>
        <p class="bold">5.特别说明</p>
        <p class="bold">
          根据相关法律规定，在下列情况中，我们可能会依法收集并使用您的个人信息而无需征得您的同意：
        </p>
        <p class="bold">（1）与履行国家法律有关规定的义务相关的；</p>
        <p class="bold">（2）与国家安全、国防安全直接相关的；</p>
        <p class="bold">（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="bold">（4）与犯罪侦查、起诉、审判和判决执行直接相关的；</p>
        <p class="bold">
          （5）出于维护您或他人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p class="bold">（6）所收集的个人信息是您自行向社会公众公开的；</p>
        <p class="bold">（7）从合法公开披露的信息中收集个人信息；</p>
        <p class="bold">（8）根据您的要求签订和履行合同所必要的；</p>
        <p class="bold">（9）其他法律许可的行为。</p>
        <p class="bold mb20">
          请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策及相应用户协议约定使用、存储、对外提供及保护您的信息。如您选择不提供前述信息，您可能无法使用某些或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体可能会通过【精臣进销存】向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供，涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。
        </p>

        <h3 class="bold">二、我们如何存储和保护信息</h3>
        <p>
          1.除非法律另有规定，我们向您提供服务所收集的信息将存储在中华人民共和国境内，我们将采取一切必要措施保护您的个人信息安全，例如在技术开发环境中，我们仅使用经过去标识化处理的信息进行统计分析；对外提供研究报告时，我们将对报告中所包含的信息进行去标识化处理。
        </p>
        <p>
          2.
          为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、损毁、误用、非授权访问、非授权披露和更改的风险。例如：
        </p>
        <p>（1）使用加密的通讯协议确保数据在传输过程中以非明文方式传递；</p>
        <p>（2）针对应用做安全加固, 确保在反编译时无法获取敏感信息；</p>
        <p>（3）业界标准的授权机制, 确保操作由本人发起；</p>
        <p>（4）数据存储全部在内网完成, 无公开的访问入口；</p>
        <p>（5）用户的敏感信息(如手机号, 密码等）都以密文进行数据存储。</p>
        <p>
          3.
          我们已制定个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训，使其掌握岗位职责和应急处理策略和规程。在发生不幸的信息安全事件后，我们将按照法律法规要求及时向您告知基本情况和可能的影响、我们已经或将要采取的措施等。我们将通过APP、短信等方式及时将相关情况发送给您。若您的合法权益受到侵害的，我们将承担相应的法律责任。
        </p>
        <p class="bold">
          4.请您务必妥善保管好您的账号、密码及相关身份要素。在您使用我们的服务时，我们会通过您的登录名或其他身份信息来识别您的身份。一旦您的泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现您的登录名或其他身份信息遭到泄露，请立即与我们联系，以便我们及时采取相应措施以避免或降低相关损失。
        </p>
        <p class="mb20">
          5.在您终止使用我们的服务后，我们会停止对您的信息的收集和使用，法律另有规定的除外。如我们停止运营，我们会及时停止收集您的个人信息，并将停止运营的通知逐一或者公告的形式通知您，并对您的个人信息进行删除或者匿名化处理。
        </p>
        <h3 class="bold">三、我们如何使用信息</h3>
        <p>
          1.为了遵守法律的监管要求，以及向您提供更好的产品和服务，保障您的个人信息安全，我们会在以下情况中使用您的信息：
        </p>
        <p>（1）实现本政策中“我们如何收集信息”所述目的；</p>
        <p>
          （2）为了保障服务的稳定性和安全性，保护您的信息安全，我们会将您的信息用于身份验证、安全防范、非法或可疑交易的监控、预防或禁止非法活动、降低风险及防止风险传导、存档和备份用途；
        </p>
        <p>（3）邀请您参与我们服务有关的调研或其他活动；</p>
        <p>
          （4）我们会采取脱敏、去标识化等方式对您的信息进行综合统计、分析加工，以便为您提供更加准确、个性、流畅和便捷的服务，或帮助我们评估、改善或设计服务及运营活动；
        </p>
        <p>（5）其他经过您同意的情形。</p>
        <p class="bold mb20">
          2.当我们要将信息用于本政策未载明的其他用途之前，会按照法律要求以确认协议、弹窗提示、具体场景下的文案确认动作等形式再次征得您的同意。
        </p>

        <h3 class="bold">四、我们如何对外提供信息</h3>
        <p class="bold">1.共享</p>
        <p>
          （1）在获取明确同意的情况下共享，即在获得您的明确同意后，我们可能会与第三方共享您的个人信息，必要时做去标识化处理。
        </p>
        <p>（2）我们可能会按照法律的要求等，与相关的第三方共享您的个人信息。</p>
        <p>
          （3）为实现本政策中声明的若干目的，我们的某些服务可能将由第三方合作伙伴提供。我们可能会与第三方合作伙伴共享您的个人信息，以提供更好的客户服务和用户体验。<span
            class="bold"
            >我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。除非得到您的许可，我们不会将您的个人信息用于本政策规定范围之外的用途或目的。</span
          >
        </p>
        <p class="bold">2.转让</p>
        <p>
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
        </p>
        <p>（1）事先获得您的明确授权或同意；</p>
        <p>（2）满足法律要求或司法裁定；</p>
        <p>
          如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求持有您个人信息的新的主体继续受本政策的约束，并通过特定方式告知且取得您的同意。
        </p>
        <p class="bold">3.公开披露</p>
        <p>我们仅会在以下情形下，公开披露您的个人信息：</p>
        <p>（1）获得您的明确同意；</p>
        <p>（2）在公布中奖活动名单时会脱敏展示中奖者手机号或账户登录名；</p>
        <p>（3）基于法律的要求。</p>
        <p class="bold">
          4.共享、转让、公开披露个人信息时事先征得授权同意的例外
        </p>
        <p class="bold">
          在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        </p>
        <p class="bold">（1）与国家安全直接相关的；</p>
        <p class="bold">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="bold">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p class="bold">
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p class="bold">（5）您自行向社会公众公开的个人信息；</p>
        <p class="bold">
          （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p class="bold">（7）根据个人信息主体要求签订和履行合同所必需的；</p>
        <p class="bold">
          （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p class="bold">（9）法律规定的其他情形。</p>
        <p class="bold mb20">
          您知悉并认可，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类此类的保存及处理将无需另行向您通知并征得您的同意。
        </p>
        <h3 class="bold">五．您将如何访问和管理自己的信息</h3>
        <p>
          1.您可通过【精臣进销存】登录您的账户，在
          【我的】-【账号管理】中查阅、修改您的身份信息等。如需要修改您的登录账号信息，出于用户数据信息安全性和身份识别的考虑或者根据法律要求，您需要通过验证方可修改您已经认证的相关信息。
        </p>
        <p>
          2.您可以通过如下途径修改您的授权范围：1、通过系统应用设置中取消相关权限；2、【我的】-【账号管理】取消相关权限。在您取消信息收集的授权后，我们将不再收集该信息，但这可能影响您使用【精臣进销存】的某些功能；在您取消向第三方共享信息的授权后，我们将不再在该业务场景下向该第三方提供信息。<span
            class="bold"
            >请您知晓，如您取消相关授权范围的，可能会影响与该授权范围相关的产品或服务功能的使用，但不影响其他功能的使用。</span
          >
        </p>
        <p>
          3.您可以通过如下途径注销您的账户：
          在【我的】-【账号管理】-【用户注销】中注销您的账号，我们将在收到您的注销申请后15个工作日内完成您的账户注销
          。<span class="bold"
            >请您知晓，当您实际注销您的账户后，您账户内的所有信息将被永久清空，我们将不会在收集、使用或对外提供与该账户相关的个人信息。</span
          >但在您使用期间提供或产生的信息，我们仍然需按照法律规定予以保存。
        </p>
        <p>
          4.如果您需要查询、修改、更正或删除您的个人信息，或对您的个人信息保护问题有任何疑问或投诉、举报、建议，您可以通过拨打客服电话【400-8608800】或发送邮件至精臣电子邮箱【kefu@niimbot.com】，精臣将15个工作日内回应并处理您的问题。
        </p>
        <p>
          5.尽管有上述约定，但按照国家法律要求，在以下情形中，我们可能无法响应您的请求：
        </p>
        <p class="bold">（1）与国家安全、国防安全直接相关的；</p>
        <p class="bold">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="bold">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p class="bold">（4）有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p class="bold">
          （5）响应您的请求将导致其他个人、组织的合法权利收到严重损害的；
        </p>
        <p class="bold">（6）涉及商业秘密的；</p>
        <p class="bold mb20">（7）法律规定的其他情形。</p>
        <h3 class="bold">六．对第三方责任的说明</h3>
        <p class="bold">
          请您注意，我们为您提供的产品和服务中可能接入第三方服务，该第三方可能有自己的隐私权保护政策。当您查看、使用第三方服务时，该第三方可能会放置他们自己的cookie或其他类似工具且不受我们控制和本政策的约束。我们会努力去要求这些第三方主体对您的信息采取保护措施，建议您与他们联系以获得他们的隐私权保护政策的详细情况。如您发现第三方应用程序或工具存在风险的，建议您终止相关操作以保护您的合法权利。
        </p>
        <p class="bold mb20 decoration cursor-p color-blue" @click="fnGoSdkNote">更多详情，敬请查阅附件1：《第三方SDK目录》。</p>
        <h3 class="bold">七．我们如何保护未成年人的信息</h3>
        <p class="bold">
          我们非常重视对未成年人信息的保护，若您属于您所在国法律规定的未成年范围的，请您在使用我们的产品和服务之前，事先取得您父母或其他监护人的同意，建议您的父母或其他监护人仔细阅读本政策。
        </p>
        <p class="bold mb20">
          一旦您以任何方式下载、安装、使用我们的产品或服务的任何部分或全部，即表明您父母或监护人同意您使用我们的产品或服务，并认可本政策的全部内容。如果父母或监护人有理由相信该未成年人未经其事先同意而向我们提交了未成年人的个人信息，请联系我们以确保删除此类个人信息。
        </p>
        <h3 class="bold">八．本政策的适用与更新</h3>
        <p class="bold">
          我们所有的产品或服务均适用本政策，除非相关服务已有独立的隐私权政策或相应的用户服务协议当中存在特别约定。
        </p>
        <p class="bold">发现下列情况时，我们会适时对本政策予以更新：</p>
        <p class="bold">
          （1）我们的基本情况发生变化，如收购、兼并、重组引起的所有者变更；
        </p>
        <p class="bold">（2）对外提供个人信息的对象、范围、目的发生变化的；</p>
        <p class="bold">
          （3）收集、存储、使用个人信息的范围、目的、规则发生变化的；
        </p>
        <p class="bold">（4）您访问和管理个人信息的方式发生变化的；</p>
        <p class="bold">
          （5）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联系方式发生变化的；
        </p>
        <p class="bold">（6）其他可能会对您个人信息权益产生重大影响的变化。</p>
        <p class="bold">
          如本政策发生更新的，我们将以APP弹窗提示等方式告知您并取得您的同意。为了您能及时接到通知，建议您在联系方式发生变更时及时通知我们。如您在本政策更新后继续使用我们的产品或服务，您应当理解并接受更新后的政策并愿意接受更新后政策的约束，如果您不接受修改后的协议，应当停止使用本软件。
        </p>
        <p class="bold mb20">
          您可以在
          【我的】-【设置】-【隐私声明】中查阅本政策全文，我们鼓励您在每次使用我们的产品或服务时都查阅我们的隐私政策。
        </p>
        <h3 class="bold">九．其他</h3>
        <p>
          9.1
          如您对我们的服务有意见，欢迎您的反馈；若您和我们之间有任何纠纷或争议，我们将友好协商解决。
        </p>
        <p>
          9.2
          本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        </p>
        <p>
          9.3
          本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
        <p>
          9.4
          如您所在国法律与本协议约定存在冲突的，请立即且毫不迟疑的告知我们，我们将根据您所在国法律规定保护您的合法权益。除非法律另有规定，本协议所述“您所在国”系指您经常居住地所在国家的相关法律。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    fnGoSdkNote() {
      this.$router.push("/sdk_note");
    },
  },
};
</script>

<style lang="less" scoped>
</style>
